/**
 * Sprint API Documentation
 * Sprint API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: developer@sprintapp.co
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type CountryCode = 'AF' | 'AX' | 'AL' | 'DZ' | 'AS' | 'AD' | 'AO' | 'AI' | 'AQ' | 'AG' | 'AR' | 'AM' | 'AW' | 'AU' | 'AT' | 'AZ' | 'BH' | 'BS' | 'BD' | 'BB' | 'BY' | 'BE' | 'BZ' | 'BJ' | 'BM' | 'BT' | 'BO' | 'BQ' | 'BA' | 'BW' | 'BV' | 'BR' | 'IO' | 'BN' | 'BG' | 'BF' | 'BI' | 'KH' | 'CM' | 'CA' | 'CV' | 'KY' | 'CF' | 'TD' | 'CL' | 'CN' | 'CX' | 'CC' | 'CO' | 'KM' | 'CG' | 'CD' | 'CK' | 'CR' | 'CI' | 'HR' | 'CU' | 'CW' | 'CY' | 'CZ' | 'DK' | 'DJ' | 'DM' | 'DO' | 'EC' | 'EG' | 'SV' | 'GQ' | 'ER' | 'EE' | 'ET' | 'FK' | 'FO' | 'FJ' | 'FI' | 'FR' | 'GF' | 'PF' | 'TF' | 'GA' | 'GM' | 'GE' | 'DE' | 'GH' | 'GI' | 'GR' | 'GL' | 'GD' | 'GP' | 'GU' | 'GT' | 'GG' | 'GN' | 'GW' | 'GY' | 'HT' | 'HM' | 'VA' | 'HN' | 'HK' | 'HU' | 'IS' | 'IN' | 'ID' | 'IR' | 'IQ' | 'IE' | 'IM' | 'IL' | 'IT' | 'JM' | 'JP' | 'JE' | 'JO' | 'KZ' | 'KE' | 'KI' | 'KP' | 'KR' | 'KW' | 'KG' | 'LA' | 'LV' | 'LB' | 'LS' | 'LR' | 'LY' | 'LI' | 'LT' | 'LU' | 'MO' | 'MK' | 'MG' | 'MW' | 'MY' | 'MV' | 'ML' | 'MT' | 'MH' | 'MQ' | 'MR' | 'MU' | 'YT' | 'MX' | 'FM' | 'MD' | 'MC' | 'MN' | 'ME' | 'MS' | 'MA' | 'MZ' | 'MM' | 'NA' | 'NR' | 'NP' | 'NL' | 'NC' | 'NZ' | 'NI' | 'NE' | 'NG' | 'NU' | 'NF' | 'MP' | 'NO' | 'OM' | 'PK' | 'PW' | 'PS' | 'PA' | 'PG' | 'PY' | 'PE' | 'PH' | 'PN' | 'PL' | 'PT' | 'PR' | 'QA' | 'RE' | 'RO' | 'RU' | 'RW' | 'BL' | 'SH' | 'KN' | 'LC' | 'MF' | 'PM' | 'VC' | 'WS' | 'SM' | 'ST' | 'SA' | 'SN' | 'RS' | 'SC' | 'SL' | 'SG' | 'SX' | 'SK' | 'SI' | 'SB' | 'SO' | 'ZA' | 'GS' | 'SS' | 'ES' | 'LK' | 'SD' | 'SR' | 'SJ' | 'SZ' | 'SE' | 'CH' | 'SY' | 'TW' | 'TJ' | 'TZ' | 'TH' | 'TL' | 'TG' | 'TK' | 'TO' | 'TT' | 'TN' | 'TR' | 'TM' | 'TC' | 'TV' | 'UG' | 'UA' | 'AE' | 'GB' | 'US' | 'UM' | 'UY' | 'UZ' | 'VU' | 'VE' | 'VN' | 'VG' | 'VI' | 'WF' | 'EH' | 'YE' | 'ZM' | 'ZW';

export const CountryCode = {
    Af: 'AF' as CountryCode,
    Ax: 'AX' as CountryCode,
    Al: 'AL' as CountryCode,
    Dz: 'DZ' as CountryCode,
    As: 'AS' as CountryCode,
    Ad: 'AD' as CountryCode,
    Ao: 'AO' as CountryCode,
    Ai: 'AI' as CountryCode,
    Aq: 'AQ' as CountryCode,
    Ag: 'AG' as CountryCode,
    Ar: 'AR' as CountryCode,
    Am: 'AM' as CountryCode,
    Aw: 'AW' as CountryCode,
    Au: 'AU' as CountryCode,
    At: 'AT' as CountryCode,
    Az: 'AZ' as CountryCode,
    Bh: 'BH' as CountryCode,
    Bs: 'BS' as CountryCode,
    Bd: 'BD' as CountryCode,
    Bb: 'BB' as CountryCode,
    By: 'BY' as CountryCode,
    Be: 'BE' as CountryCode,
    Bz: 'BZ' as CountryCode,
    Bj: 'BJ' as CountryCode,
    Bm: 'BM' as CountryCode,
    Bt: 'BT' as CountryCode,
    Bo: 'BO' as CountryCode,
    Bq: 'BQ' as CountryCode,
    Ba: 'BA' as CountryCode,
    Bw: 'BW' as CountryCode,
    Bv: 'BV' as CountryCode,
    Br: 'BR' as CountryCode,
    Io: 'IO' as CountryCode,
    Bn: 'BN' as CountryCode,
    Bg: 'BG' as CountryCode,
    Bf: 'BF' as CountryCode,
    Bi: 'BI' as CountryCode,
    Kh: 'KH' as CountryCode,
    Cm: 'CM' as CountryCode,
    Ca: 'CA' as CountryCode,
    Cv: 'CV' as CountryCode,
    Ky: 'KY' as CountryCode,
    Cf: 'CF' as CountryCode,
    Td: 'TD' as CountryCode,
    Cl: 'CL' as CountryCode,
    Cn: 'CN' as CountryCode,
    Cx: 'CX' as CountryCode,
    Cc: 'CC' as CountryCode,
    Co: 'CO' as CountryCode,
    Km: 'KM' as CountryCode,
    Cg: 'CG' as CountryCode,
    Cd: 'CD' as CountryCode,
    Ck: 'CK' as CountryCode,
    Cr: 'CR' as CountryCode,
    Ci: 'CI' as CountryCode,
    Hr: 'HR' as CountryCode,
    Cu: 'CU' as CountryCode,
    Cw: 'CW' as CountryCode,
    Cy: 'CY' as CountryCode,
    Cz: 'CZ' as CountryCode,
    Dk: 'DK' as CountryCode,
    Dj: 'DJ' as CountryCode,
    Dm: 'DM' as CountryCode,
    Do: 'DO' as CountryCode,
    Ec: 'EC' as CountryCode,
    Eg: 'EG' as CountryCode,
    Sv: 'SV' as CountryCode,
    Gq: 'GQ' as CountryCode,
    Er: 'ER' as CountryCode,
    Ee: 'EE' as CountryCode,
    Et: 'ET' as CountryCode,
    Fk: 'FK' as CountryCode,
    Fo: 'FO' as CountryCode,
    Fj: 'FJ' as CountryCode,
    Fi: 'FI' as CountryCode,
    Fr: 'FR' as CountryCode,
    Gf: 'GF' as CountryCode,
    Pf: 'PF' as CountryCode,
    Tf: 'TF' as CountryCode,
    Ga: 'GA' as CountryCode,
    Gm: 'GM' as CountryCode,
    Ge: 'GE' as CountryCode,
    De: 'DE' as CountryCode,
    Gh: 'GH' as CountryCode,
    Gi: 'GI' as CountryCode,
    Gr: 'GR' as CountryCode,
    Gl: 'GL' as CountryCode,
    Gd: 'GD' as CountryCode,
    Gp: 'GP' as CountryCode,
    Gu: 'GU' as CountryCode,
    Gt: 'GT' as CountryCode,
    Gg: 'GG' as CountryCode,
    Gn: 'GN' as CountryCode,
    Gw: 'GW' as CountryCode,
    Gy: 'GY' as CountryCode,
    Ht: 'HT' as CountryCode,
    Hm: 'HM' as CountryCode,
    Va: 'VA' as CountryCode,
    Hn: 'HN' as CountryCode,
    Hk: 'HK' as CountryCode,
    Hu: 'HU' as CountryCode,
    Is: 'IS' as CountryCode,
    In: 'IN' as CountryCode,
    Id: 'ID' as CountryCode,
    Ir: 'IR' as CountryCode,
    Iq: 'IQ' as CountryCode,
    Ie: 'IE' as CountryCode,
    Im: 'IM' as CountryCode,
    Il: 'IL' as CountryCode,
    It: 'IT' as CountryCode,
    Jm: 'JM' as CountryCode,
    Jp: 'JP' as CountryCode,
    Je: 'JE' as CountryCode,
    Jo: 'JO' as CountryCode,
    Kz: 'KZ' as CountryCode,
    Ke: 'KE' as CountryCode,
    Ki: 'KI' as CountryCode,
    Kp: 'KP' as CountryCode,
    Kr: 'KR' as CountryCode,
    Kw: 'KW' as CountryCode,
    Kg: 'KG' as CountryCode,
    La: 'LA' as CountryCode,
    Lv: 'LV' as CountryCode,
    Lb: 'LB' as CountryCode,
    Ls: 'LS' as CountryCode,
    Lr: 'LR' as CountryCode,
    Ly: 'LY' as CountryCode,
    Li: 'LI' as CountryCode,
    Lt: 'LT' as CountryCode,
    Lu: 'LU' as CountryCode,
    Mo: 'MO' as CountryCode,
    Mk: 'MK' as CountryCode,
    Mg: 'MG' as CountryCode,
    Mw: 'MW' as CountryCode,
    My: 'MY' as CountryCode,
    Mv: 'MV' as CountryCode,
    Ml: 'ML' as CountryCode,
    Mt: 'MT' as CountryCode,
    Mh: 'MH' as CountryCode,
    Mq: 'MQ' as CountryCode,
    Mr: 'MR' as CountryCode,
    Mu: 'MU' as CountryCode,
    Yt: 'YT' as CountryCode,
    Mx: 'MX' as CountryCode,
    Fm: 'FM' as CountryCode,
    Md: 'MD' as CountryCode,
    Mc: 'MC' as CountryCode,
    Mn: 'MN' as CountryCode,
    Me: 'ME' as CountryCode,
    Ms: 'MS' as CountryCode,
    Ma: 'MA' as CountryCode,
    Mz: 'MZ' as CountryCode,
    Mm: 'MM' as CountryCode,
    Na: 'NA' as CountryCode,
    Nr: 'NR' as CountryCode,
    Np: 'NP' as CountryCode,
    Nl: 'NL' as CountryCode,
    Nc: 'NC' as CountryCode,
    Nz: 'NZ' as CountryCode,
    Ni: 'NI' as CountryCode,
    Ne: 'NE' as CountryCode,
    Ng: 'NG' as CountryCode,
    Nu: 'NU' as CountryCode,
    Nf: 'NF' as CountryCode,
    Mp: 'MP' as CountryCode,
    No: 'NO' as CountryCode,
    Om: 'OM' as CountryCode,
    Pk: 'PK' as CountryCode,
    Pw: 'PW' as CountryCode,
    Ps: 'PS' as CountryCode,
    Pa: 'PA' as CountryCode,
    Pg: 'PG' as CountryCode,
    Py: 'PY' as CountryCode,
    Pe: 'PE' as CountryCode,
    Ph: 'PH' as CountryCode,
    Pn: 'PN' as CountryCode,
    Pl: 'PL' as CountryCode,
    Pt: 'PT' as CountryCode,
    Pr: 'PR' as CountryCode,
    Qa: 'QA' as CountryCode,
    Re: 'RE' as CountryCode,
    Ro: 'RO' as CountryCode,
    Ru: 'RU' as CountryCode,
    Rw: 'RW' as CountryCode,
    Bl: 'BL' as CountryCode,
    Sh: 'SH' as CountryCode,
    Kn: 'KN' as CountryCode,
    Lc: 'LC' as CountryCode,
    Mf: 'MF' as CountryCode,
    Pm: 'PM' as CountryCode,
    Vc: 'VC' as CountryCode,
    Ws: 'WS' as CountryCode,
    Sm: 'SM' as CountryCode,
    St: 'ST' as CountryCode,
    Sa: 'SA' as CountryCode,
    Sn: 'SN' as CountryCode,
    Rs: 'RS' as CountryCode,
    Sc: 'SC' as CountryCode,
    Sl: 'SL' as CountryCode,
    Sg: 'SG' as CountryCode,
    Sx: 'SX' as CountryCode,
    Sk: 'SK' as CountryCode,
    Si: 'SI' as CountryCode,
    Sb: 'SB' as CountryCode,
    So: 'SO' as CountryCode,
    Za: 'ZA' as CountryCode,
    Gs: 'GS' as CountryCode,
    Ss: 'SS' as CountryCode,
    Es: 'ES' as CountryCode,
    Lk: 'LK' as CountryCode,
    Sd: 'SD' as CountryCode,
    Sr: 'SR' as CountryCode,
    Sj: 'SJ' as CountryCode,
    Sz: 'SZ' as CountryCode,
    Se: 'SE' as CountryCode,
    Ch: 'CH' as CountryCode,
    Sy: 'SY' as CountryCode,
    Tw: 'TW' as CountryCode,
    Tj: 'TJ' as CountryCode,
    Tz: 'TZ' as CountryCode,
    Th: 'TH' as CountryCode,
    Tl: 'TL' as CountryCode,
    Tg: 'TG' as CountryCode,
    Tk: 'TK' as CountryCode,
    To: 'TO' as CountryCode,
    Tt: 'TT' as CountryCode,
    Tn: 'TN' as CountryCode,
    Tr: 'TR' as CountryCode,
    Tm: 'TM' as CountryCode,
    Tc: 'TC' as CountryCode,
    Tv: 'TV' as CountryCode,
    Ug: 'UG' as CountryCode,
    Ua: 'UA' as CountryCode,
    Ae: 'AE' as CountryCode,
    Gb: 'GB' as CountryCode,
    Us: 'US' as CountryCode,
    Um: 'UM' as CountryCode,
    Uy: 'UY' as CountryCode,
    Uz: 'UZ' as CountryCode,
    Vu: 'VU' as CountryCode,
    Ve: 'VE' as CountryCode,
    Vn: 'VN' as CountryCode,
    Vg: 'VG' as CountryCode,
    Vi: 'VI' as CountryCode,
    Wf: 'WF' as CountryCode,
    Eh: 'EH' as CountryCode,
    Ye: 'YE' as CountryCode,
    Zm: 'ZM' as CountryCode,
    Zw: 'ZW' as CountryCode
};

